export function mergeRectangles(rects) {
  if (!rects || rects.length < 2) return rects;

  const groups = new Map();
  for (const rect of rects) {
    const key = `${rect.normalizedTop.toFixed(4)}|${rect.normalizedHeight.toFixed(4)}`;
    if (!groups.has(key)) {
      groups.set(key, []);
    }
    groups.get(key).push({
      left: rect.normalizedLeft,
      width: rect.normalizedWidth
    });
  }

  const mergedRects = [];

  for (const [key, horizontalSpans] of groups.entries()) {
    horizontalSpans.sort((a, b) => a.left - b.left);

    const [topStr, heightStr] = key.split('|');
    const normalizedTop = parseFloat(topStr);
    const normalizedHeight = parseFloat(heightStr);

    let currentMerged = null;

    for (const span of horizontalSpans) {
      if (!currentMerged) {
        currentMerged = { ...span };
      } else {
        const currentEnd = currentMerged.left + currentMerged.width;
        const spanStart = span.left;
        const spanEnd = span.left + span.width;

        if (spanStart <= currentEnd + 0.001) {
          currentMerged.width = Math.max(currentEnd, spanEnd) - currentMerged.left;
        } else {
          mergedRects.push({
            pageNumber: rects[0].pageNumber,
            normalizedTop,
            normalizedHeight,
            normalizedLeft: currentMerged.left,
            normalizedWidth: currentMerged.width,
          });
          currentMerged = { ...span };
        }
      }
    }

    if (currentMerged) {
      mergedRects.push({
        pageNumber: rects[0].pageNumber,
        normalizedTop,
        normalizedHeight,
        normalizedLeft: currentMerged.left,
        normalizedWidth: currentMerged.width,
      });
    }
  }

  return mergedRects;
}